import React from "react";
import GraphicEqualiser from "../graphicEqualiser/GraphicEqualiser";
import styles from "./timeDisplay.module.css";

export default function TimeDisplay({ currSeconds, ampVals }) {
  const { minStr, secsStr, msStr } = getTimeData(currSeconds);

  return (
    <div className={styles.background}>
      <div className={styles.panel}>
        <div className={styles.screen}>
          <div className={styles.time}>
            {minStr}:{secsStr}:{msStr}
          </div>
          <GraphicEqualiser ampVals={ampVals} />
        </div>
      </div>
    </div>
  );
}

function getTimeData(seconds) {
  if (!seconds) seconds = 0;

  const mins = Math.floor(seconds / 60);
  const secondsWithDecimals = seconds - mins * 60;
  const secs = Math.floor(secondsWithDecimals);
  const ms = Math.round((secondsWithDecimals - secs) * 100);

  const minStr = mins < 10 ? "0" + mins : "" + mins;
  const secsStr = secs < 10 ? "0" + secs : "" + secs;
  const msStr = ms < 10 ? "0" + ms : "" + ms;

  // ensuring retricted to 2 digits
  return {
    minStr: minStr.substr(0, 2),
    secsStr: secsStr.substr(0, 2),
    msStr: msStr.substr(0, 2),
  };
}
